import { useState } from "react"

import { App, Flex, Modal, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import TextAreaComponent from "../../../../Components/Input/TextArea"
import Icon from "../../../../Icon"
import Creators from "../../reducer"

import styles from "./SwitchToLoyalBillingModal.module.less"

const { Text } = Typography

export const SwitchToLoyalBillingModal = ({ modalType, setModalType, onSuccess }) => {
  const dispatch = useDispatch()
  const { modal } = App.useApp()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { switchToLoyalBillingFetching } = useSelector((state) => state.users)
  const [comment, setComment] = useState("")

  const record = modalType?.record

  const handleCloseModal = () => {
    setModalType(false)
  }

  const handleConfirmSwitch = () => {
    modal.confirm({
      width: 442,
      icon: null,
      closable: true,
      closeIcon: <Icon type="cross_small" />,
      centered: !isMobile,
      className: `clear-bg ${styles.confirmModal}`,
      title: `Are you sure you want to switch ${record?.user_full_name} from Standard to Loyal billing?`,
      content: <Text type="secondary">This action cannot be undone.</Text>,
      cancelText: "Cancel",
      okText: "Confirm",
      cancelButtonProps: { size: "large" },
      okButtonProps: { size: "large" },
      onOk() {
        dispatch(
          Creators.switchToLoyalBillingRequest({
            userId: record?.id,
            ...(comment && { comment }),
            onSuccess: () => {
              handleCloseModal()
              onSuccess?.()
            }
          })
        )
      }
    })
  }

  return (
    <Modal
      open={modalType?.type === "switch_to_loyal_billing"}
      centered={!isMobile}
      width={442}
      title={"Switch billing type"}
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      getContainer={() => document.getElementById("main-layout")}
      closeIcon={<Icon type="cross_small" />}
    >
      <Flex vertical gap={24}>
        <Text type="secondary">
          On loyal billing users billed via bank transfer instead of card-based balance payments.
        </Text>

        <div className={styles.infoGrid}>
          <Flex vertical gap={4}>
            <Text type="secondary">Current billing type</Text>
            <Text strong>Standard</Text>
          </Flex>
          <Flex vertical gap={4}>
            <Text type="secondary">Target billing type</Text>
            <Text strong>Loyal billing</Text>
          </Flex>
          <Flex vertical gap={4}>
            <Text type="secondary">User full name</Text>
            <Text strong>{record?.user_full_name}</Text>
          </Flex>
          <Flex vertical gap={4}>
            <Text type="secondary">User email</Text>
            <Text strong ellipsis={{ tooltip: record?.user_email }}>
              {record?.user_email}
            </Text>
          </Flex>
        </div>

        <TextAreaComponent
          rows={3}
          placeholder="Internal comment, add a note about this change..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Flex>

      <Flex gap={12} justify="end" style={{ marginTop: 24 }}>
        <ButtonComponent size="large" onClick={handleCloseModal}>
          Cancel
        </ButtonComponent>
        <ButtonComponent
          size="large"
          type="primary"
          loading={switchToLoyalBillingFetching}
          onClick={handleConfirmSwitch}
        >
          Confirm Switch
        </ButtonComponent>
      </Flex>
    </Modal>
  )
}
